import PropTypes from 'prop-types';

import H1 from 'core/components/H1';
import Indent from 'core/components/Wrappers/Indent';


function LegalPageTitle({ title }) {
  return (
    <Indent top={40} bottom={40}>
      <H1>{title}</H1>
    </Indent>
  );
}

LegalPageTitle.propTypes = {
  title: PropTypes.string,
};
export default LegalPageTitle;
